const actionType = {
    GET_ALL_RECON_CONFIGURATION_SUCCESS: 'GET_ALL_RECON_CONFIGURATION_SUCCESS',
    GET_RECON_CONFIGURATION_SUCCESS: 'GET_RECON_CONFIGURATION_SUCCESS',
    GET_RECON_CONFIGURATION_SUCCESS_FOR_SIDEBAR: 'GET_RECON_CONFIGURATION_SUCCESS_FOR_SIDEBAR',
    GET_RECON_DEFAULT_MAPPING_SUCCESS: 'GET_RECON_DEFAULT_MAPPING_SUCCESS',
    GET_RECON_SOURCE_NAME_MAPPINGS: 'GET_RECON_SOURCE_NAME_MAPPINGS',
    GET_RECON_SOURCE_FILTER_SUCCESS: 'GET_RECON_SOURCE_FILTER_SUCCESS',
    GET_RECON_FIELD_MAPPING_SUCCESS: 'GET_RECON_FIELD_MAPPING_SUCCESS',
    GET_RECON_SOURCE_FIELD_MAPPINGS_SUCCESS: 'GET_RECON_SOURCE_FIELD_MAPPINGS_SUCCESS',
    GET_RECON_SOURCE_FIELD_MAPPINGS_SUCCESS_COPY: 'GET_RECON_SOURCE_FIELD_MAPPINGS_SUCCESS_COPY',
    GET_RECON_SOURCE_FIELD_SQL_EXPRESSION_SUCCESS: 'GET_RECON_SOURCE_FIELD_SQL_EXPRESSION_SUCCESS',
    GET_RECON_CALCULATION_FILTER_SUCCESS: 'GET_RECON_CALCULATION_FILTER_SUCCESS',
    SET_IS_SHOW_MODAL: 'SET_IS_SHOW_MODAL',
    SET_IS_AUTO_MAP: 'SET_IS_AUTO_MAP',

    GET_RECON_SOURCE_AGGREGATION_RESULT: 'GET_RECON_SOURCE_AGGREGATION_RESULT',
    GET_RECON_SOURCE_LOOKUP_CONFIGURATION_SUCCESS: 'GET_RECON_SOURCE_LOOKUP_CONFIGURATION_SUCCESS',

    GET_RECON_SUMMARY_TYPES: 'GET_RECON_SUMMARY_TYPES',
    GET_RECON_FIELD_SETTINGS: 'GET_RECON_FIELD_SETTINGS',
    GET_MANUAL_TRIGGER_EVENTS: 'GET_MANUAL_TRIGGER_EVENTS',
    CLEAR_MANUAL_TRIGGER_EVENTS: 'CLEAR_MANUAL_TRIGGER_EVENTS',
    GET_ALL_SHARED_USERS: 'GET_ALL_SHARED_USERS',
    GET_ALL_LINKED_REC_SRC: 'GET_ALL_LINKED_REC_SRC',
};
export default actionType;
